import { Outlet, useLocation } from 'react-router'
import { Header } from './Header'
import { DEFAULT_HEADER_STATE, HeaderProvider, useSetHeaderContext } from './HeaderContext'
import { memo } from 'react'
import { Footer } from './Footer'
import { MAIN_HEADER_HEIGHT } from '@/catalog-apps/components/config'
import { AppPageStateProvider } from '@/catalog-apps/components/AppPage2/useAppPageState'
import { AiChatComponentContextProvider } from '@/catalog-apps/components/AppSupportMenuAiChat/useAiChatComponentContext'
import { ProjectsOrganisationFilterProvider } from '@/pages/Projects/ProjectsOrganisationFilterContext'

function isMarketingHomePath(pathname: string) {
  return pathname === '/'
}

export function MainLayout() {
  const { pathname } = useLocation()
  const isMarketingHome = isMarketingHomePath(pathname)

  return (
    <div
      // style={{ gridTemplateRows: `${MAIN_HEADER_HEIGHT}px 1fr ${MAIN_HEADER_HEIGHT}px` }}
      className="flex h-screen w-screen flex-col text-foreground"
    >
      <HeaderProvider>
        <AppPageStateProvider>
          <AiChatComponentContextProvider>
            <HeaderRouteDefaults />
            <ProjectsOrganisationFilterProvider>
              <Header />
              <MainContent pinFooter={!isMarketingHome} />
            </ProjectsOrganisationFilterProvider>
            {!isMarketingHome && <Footer />}
          </AiChatComponentContextProvider>
        </AppPageStateProvider>
      </HeaderProvider>
    </div>
  )
}

const MainContent = memo(function MainContent({ pinFooter }: { pinFooter: boolean }) {
  return (
    <div
      style={{ height: `calc(100vh - ${MAIN_HEADER_HEIGHT * (pinFooter ? 2 : 1)}px)` }}
      className="min-w-0 flex-1 bg-offwhite"
    >
      <Outlet />
    </div>
  )
})

function HeaderRouteDefaults() {
  const { pathname } = useLocation()

  return usesManagedHeader(pathname) ? null : <DefaultHeaderOwner />
}

function DefaultHeaderOwner() {
  useSetHeaderContext(DEFAULT_HEADER_STATE)

  return null
}

function usesManagedHeader(pathname: string) {
  const segments = pathname.split('/').filter(Boolean)

  if (segments.length === 0) {
    return false
  }

  if (segments[0] === 'docs') {
    return true
  }

  if (segments[0] === 'workspaces' && segments.length >= 2) {
    return true
  }

  if (segments[0] === 'applications' && segments.length >= 2) {
    return true
  }

  if (segments[0] === 'subscriptions' && segments.length >= 2) {
    return true
  }

  if (segments[0] === 'projects' && segments.length >= 2) {
    return true
  }

  if (segments[0] === 'apps' && segments.length >= 3) {
    return true
  }

  return !STATIC_ROUTE_PREFIXES.has(segments[0])
}

const STATIC_ROUTE_PREFIXES = new Set([
  'oauth',
  'workspaces',
  'applications',
  'subscriptions',
  'projects',
  'platform',
  'docs',
  'chat-test',
  'apps',
  'featured-apps',
  'home-v2',
])
